export default "__VITE_ASSET__JV35wJGH__"